package com.example.webcv.pages.portfolio.model

data class PortfolioItem(
    val title: String,
    val platform: String,
    val imageUrl: String,
    val category: String,
    val url: String
)